import { useEffect, useState } from 'react';
import API from '../../api';

export default function EtudiantNotes() {
  const [coursNotes, setCoursNotes] = useState([]);

  useEffect(() => {
    API.get('mes-notes/').then((r) => setCoursNotes(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <div className="page-header">
        <h2><i className="bi bi-award" /> Mes notes</h2>
      </div>

      {coursNotes.length === 0 ? (
        <div className="empty-state"><i className="bi bi-award" /><p>Aucune note disponible</p></div>
      ) : (
        coursNotes.map((cn) => (
          <div key={cn.cours_id} className="notes-cours-section">
            <h3>{cn.cours_titre} — Moyenne : <span className={`moyenne ${parseFloat(cn.moyenne) >= 10 ? 'note-success' : parseFloat(cn.moyenne) >= 8 ? 'note-warning' : 'note-danger'}`}>{parseFloat(cn.moyenne).toFixed(2)}/20</span></h3>
            <div className="data-table-wrapper">
              <table className="data-table">
                <thead><tr><th>Évaluation</th><th>Note</th><th>Barème</th><th>Commentaire</th></tr></thead>
                <tbody>
                  {cn.notes.map((n) => {
                    const pct = n.bareme ? (n.valeur / n.bareme) * 20 : 0;
                    const cls = pct >= 10 ? 'note-success' : pct >= 8 ? 'note-warning' : 'note-danger';
                    return (
                    <tr key={n.id}>
                      <td>{n.evaluation_titre}</td>
                      <td><strong className={`moyenne ${cls}`}>{parseFloat(n.valeur).toFixed(2)}</strong></td>
                      <td>/{n.bareme}</td>
                      <td>{n.commentaire}</td>
                    </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
